export function ArrowUpIcon({
  accessibilityLabel,
  className,
}: {
  readonly accessibilityLabel: string
  readonly className?: string
}) {
  const isDecorative = accessibilityLabel === ''

  return (
    <svg
      className={['ArrowUpIcon', className].filter(Boolean).join(' ')}
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden={isDecorative}
      aria-label={accessibilityLabel}
    >
      <g>
        <path
          id="Vector"
          d="M9 13.5V4.5M9 4.5L5.25 8.25M9 4.5L12.75 8.25"
          stroke="currentColor"
          strokeWidth="1.5"
        />
      </g>
    </svg>
  )
}
